import {Injectable} from '@angular/core';
import {TaskViewService} from '@mydocma/task';

@Injectable()
export class MmTaskDashboardService {
  public taskViewService: TaskViewService;
}
